import DeliveryAmount from '@/generated/controls/delivery/DeliveryAmount.vue';
import { defineComponent } from "vue";

export default defineComponent({ components: {},
    extends: DeliveryAmount
})